
import { Component, Prop, Vue } from 'vue-property-decorator';
import ContentType from '../interfaces/content-type';

@Component
export default class MokYun extends Vue {
  public configInfo: any = [];
  @Prop() private msg!: any;
  public url = '';
  jump(id: any, parentId: any, jumpType: any) {
    if (jumpType === ContentType.Url) {
      this.msg.map((v0: any) => {
        v0.child.map((v1: any) => {
          if (v1.id === id) {
            this.url = v1.jumpUrl;
          }
        });
      });
      // window.open(this.url, '_blank');
      window.open(this.url, '_self');
    } else {
      localStorage.setItem('page', String(1));
      this.$router.push({
        path: '/list',
        query: {
          id,
          parentId,
          type: jumpType,
        },
      });
      scrollTo(0, 0);
    }
  }
  jumpParent(title: any) {
    if (title === '首页') {
      this.$router.push({ name: 'Home' });
    }
  }
}
